import type { EvidencePromptSuggestion } from '@/components/ui/floating-ask-heidi';
import type { StackedSourceAvatarSource } from '@/components/ui/floating-ask-heidi/evidence-prompts-bar/evidence-prompts-bar.types';
import { atom } from 'jotai';

/**
 * Controls whether the right-side Evidence sidebar panel is open.
 * Re-exported from panelAtoms so that opening evidence automatically dismisses
 * the tasks/codes panel and verify drawer (and vice versa).
 */
export { evidenceSidebarOpenAtom } from './panelAtoms';

/**
 * Shared evidence prompts bar state — synced from FloatingAskHeidiWithChips
 * so the sidebar panel can render the same considerations list (GRO-2829).
 */
export const evidencePromptsSuggestionsAtom = atom<EvidencePromptSuggestion[]>([]);
export const evidencePromptsFaviconsAtom = atom<StackedSourceAvatarSource[]>([]);
export const evidencePromptsVisibleAtom = atom(false);
/** Shared dismiss callback — set by useEvidencePromptsBar, called from sidebar */
export const evidencePromptsDismissAtom = atom<(() => void) | null>(null);
